<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {
      positonInfo: {}
    }
  },
  mounted() {
    this.bindTouchDom()
  },
  beforeDestroy() {
    this.removeTouchDom()
  },
  methods: {
    removeTouchDom() {
      //手指接触屏幕
      document.removeEventListener('touchstart', this.pageTouchStart, {
        passive: false
      })
      document.removeEventListener('touchmove', this.pageTouchMove, {
        passive: false
      })
      //手指离开屏幕
      document.removeEventListener('touchend', this.pageTouchEnd, {
        passive: false
      })
    },
    bindTouchDom() {
      //手指接触屏幕
      document.addEventListener('touchstart', this.pageTouchStart, {
        passive: false
      })
      document.addEventListener('touchmove', this.pageTouchMove, {
        passive: false
      })
      //手指离开屏幕
      document.addEventListener('touchend', this.pageTouchEnd, {
        passive: false
      })
    },
    pageTouchStart(e) {
      this.positonInfo.startx = e.touches[0].pageX
      this.positonInfo.starty = e.touches[0].pageY
      this.positonInfo.prey = e.touches[0].pageY
    },
    pageTouchMove(e) {
      var cury
      cury = e.changedTouches[0].pageY
      let direction
      if (cury > this.positonInfo.prey) {
        direction = 2
      } else {
        direction = 1
      }
      this.positonInfo.prey = cury
      switch (direction) {
        case 0:
          break
        case 1:
          //当滑动底部的时候禁止页面默认滑动行为
          if (this.isToBottom()) {
            e.preventDefault()
          }
          break
        case 2:
          //当滑动顶部的时候禁止页面默认滑动行为
          if (this.isToTop()) {
            e.preventDefault()
          }
          break
        case 3:
          break
        case 4:
          break
        default:
          break
      }
    },
    pageTouchEnd(e) {},
    isToBottom() {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop
      let scrollHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight
      if (scrollHeight - window.screen.availHeight <= scrollTop) {
        return true
      }
      return false
    },
    isToTop() {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop
      return scrollTop <= 0
    }
  }
}
</script>
